// 0草稿 1确认中 2已驳回 3已完成
import UltMeta, { Meta } from "./UltMeta/index";

class PurchaseGoodsReceiptState extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    CONFIRMING = new Meta(2, "确认中");
    REJECTED = new Meta(3, "已驳回");
    FINISHED = new Meta(4, "已完成", "color-info");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}
export const PURCHASE_GOODS_RECEIPT_STATE = new PurchaseGoodsReceiptState();

class DownStreamPurchaseGoodsReceiptState extends UltMeta {
    CONFIRMING = new Meta(2, "确认中");
    FINISHED = new Meta(4, "已完成", "color-info");
    INVALIDING = new Meta(5, "作废中");
    INVALID = new Meta(6, "已作废");
}
export const DOWN_STREAM_PURCHASE_GOODS_RECEIPT_STATE = new DownStreamPurchaseGoodsReceiptState();

class Forward extends UltMeta {
    UNFORWARD = new Meta(0, "未转发", "#C8C8C8"); //后端不接, 需删除
    FORWARDED = new Meta(1, "已转发", "#FFDB5C");
}
export const FORWARD = new Forward();

class SignState extends UltMeta {
    UNSIGN = new Meta(0, "都没签署");
    BUYER_SIGN = new Meta(1, "买方已签");
    SELLER_SIGN = new Meta(2, "卖方已签");
    ALL_SIGN = new Meta(3, "均已签署");
}

export const SIGN_STATE = new SignState();

class SignSelf extends UltMeta {
    UNSIGN = new Meta(1, "没签署");
    SIGNED = new Meta(2, "已签署");
    OTHER = new Meta(3, "其它状态");
}

export const SIGN_SELF = new SignSelf();

/**对账状态：1.未对账/2.对账中/3.已对账 */
class RecieptReconciliationState extends UltMeta {
    INITIAL = new Meta(1, "未对账");
    PENDING = new Meta(2, "对账中");
    COMPLETED = new Meta(3, "已对账");
}

export const RECIEPT_RECONCILIATION_STATE = new RecieptReconciliationState();
